import template from './template.html'
import controller from './toolbox.controller'

export default {
  restrict: 'E',
  template,
  bindings: {},
  controller,
  controllerAs: 'vm',
}
